import request from "@/utils/request";

// 登录方法
export function login(data) {
	return request({
		url: "/system/auth/login",
		method: "post",
		data
	});
}

// 退出方法
export function logout() {
	return request({
		url: "/system/auth/logout",
		method: "post"
	});
}

// 刷新访问令牌
export function refreshToken() {
	return request({
		url:
			"/system/auth/refresh-token?refreshToken=" +
			localStorage.getItem("REFRESH_TOKEN"),
		method: "post"
	});
}
